import React from 'react';

//todo review server contact!
export const OsVersion = ({ maxValue, value, operator }) => {
  return (
    <React.Fragment>
      {maxValue ? (
        <React.Fragment>
          {value} - {maxValue}
        </React.Fragment>
      ) : (
        <React.Fragment>
          {operator?.name} {value}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
